<template>
  <c-row>
    <c-col col="12">
      <c-card>
        <loader v-show="loading" />
        <c-card-header>
          <c-card-title>
            <strong>Informasi User</strong>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div style="overflow: auto">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Email</th>
                  <th>Nama</th>
                  <th>Phone</th>
                  <th>Created</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v, k) in report.data" :key="k">
                  <td>
                    <table-number-2 :index="k" :paginate="report.paginate" />
                  </td>
                  <td>{{ v.email }}</td>
                  <td>{{ v.name }}</td>
                  <td>{{ v.phone }}</td>
                  <td>{{ v.created_at | dateTimeFormat }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
        <c-card-footer>
          <button class="btn btn-primary">
            <i class="cil-print"></i> Print</button
          >&nbsp;
          <button class="btn btn-success" @click="exportExcel">
            <i class="cil-cloud-download"></i> Excel
          </button>
          <paginator :paginator="report.paginate" @change="changePage" />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { HTTPAUTH, HTTPExport } from "../../lib/httplib";
import Loader from '../../components/Loader.vue';
import { showErrorMessage } from '../../lib/helpers';
import Paginator from '../../components/Paginator.vue';
import TableNumber2 from '../../components/TableNumber2.vue';
export default {
  data () {
    return {
      loading: true,
      report: {},
      currentPage: 1,
      total: 0,
      perPage: 10,
    };
  },
  components: {
    Loader,
    Paginator,
    TableNumber2,
  },
  created () {
    this.getList(1, "");
  },
  methods: {
    changePage (page) {
      const query = this.$route.query;
      var q = "";
      if (query.q) {
        q = query.q;
      }
      this.getList(page, q)
    },
    getList (page, q) {
      this.loading = true
      HTTPAUTH.get(
        `/api/v1/user?page=${page}&size=${this.perPage}&q=${q}`
      ).then((res) => {
        this.report = res.data;
        this.$router.push({ query: { q: q, page: page } });
        this.loading = false
      }).catch(eres => {
        this.loading = false
        showErrorMessage(eres)
      });
    },
    async exportExcel () {
      this.loading = true
      let data = null;
      await HTTPAUTH.get(`/api/v1/report-master/user/export`).then((res) => {
        data = res.data.data
      }).catch(() => {
        this.loading = false
      });
      await HTTPExport.post(`/api/v1/master/user`, data).then(res => {
        const data = res.data.data;
        window.open(data, '_blank');
      }).catch(() => {
        this.loading = false
      })
      this.loading = false
    },
  },
};
</script>